module.exports = __webpack_public_path__ + "static/media/icon_delete.9298e68b.svg";